<template>
  <form data-vv-scope="step-1">
    <div class="row mb-3">
      <div class="col-md-6">
        <list-document-types
          :type-numeration="typeNumeration"
          class="w-100"
          autocomplete
          label="Tipo Documento (*)"
          name="documentType"
          v-model="step.documentType"
          :danger="errors.has('step-1.documentType')"
          :danger-text="errors.first('step-1.documentType')"
          v-validate="'required'"
          ref="documentTypes"
        />
      </div>
      <div class="col-md-6">
        <list-documents
          :type-numeration="typeNumeration"
          class="w-100"
          autocomplete
          label="Documento (*)"
          name="document"
          v-model="step.document"
          :parent-value="step.documentType"
          :danger="errors.has('step-1.document')"
          :danger-text="errors.first('step-1.document')"
          v-validate="{'required': isRequired}"
          ref="documents"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <vs-select
          class="w-100"
          autocomplete
          label="Formato Documento"
          name="formatDocument"
          v-model="step.formatDocument"
        >
          <vs-select-item
            :value="0"
            text="Papel"
          />
          <vs-select-item
            :value="1"
            text="Electrónico"
          />
        </vs-select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <div class="row">
          <div class="col-md-4">
            <label>Documento Reservado</label>
          </div>
          <div class="col-md-1">
            <vs-radio
              vs-name="isPrivate"
              :vs-value="2"
              v-model="step.isPrivate"
            >
              Si
            </vs-radio>
          </div>
          <div class="col-md-1">
            <vs-radio
              vs-name="isPrivate"
              :vs-value="1"
              v-model="step.isPrivate"
            >
              No
            </vs-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <label for="matter">Materia (*)</label>
        <vs-textarea
          style="resize: none !important;"
          type="text"
          id="matter"
          label="Materia (Mínimo 2 palabras, máximo 5000 caracteres)"
          name="matter"
          width="100%"
          v-validate="'required|min:3'"
          height="100px"
          maxlength="5000"
          class="mb-0"
          v-model="step.matter"
        />
        <div v-if="errors.first('step-1.matter')"
             class="con-text-validation span-text-validation-danger
         vs-input--text-validation-span v-enter-to"
             style="height: 32px;">
        <span class="span-text-validation">
          {{errors.first('step-1.matter')}}
        </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListDocumentTypes from '@/febos/chile/lists/components/ListDocumentTypes';
import ListDocuments from '@/febos/chile/lists/components/ListDocuments';

export default {
  mixins: [WizardStep],
  components: {
    ListDocumentTypes,
    ListDocuments
  },
  data() {
    return {
      typeNumeration: this.$route.params.wizard,
      tag: '',
      step: {
        documentType: '',
        document: '',
        formatDocument: 1,
        matter: '',
        isPrivate: '1',
        ...this.draft
      }
    };
  },
  computed: {
    ...mapGetters('List', [
      'documentsState'
    ]),
    isRequired() {
      let documents = this.documentsState.list;
      if (this.typeNumeration === 'numOf') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numOf);
      }
      if (this.typeNumeration === 'numInt') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numInt);
      }
      return documents.length > 0;
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'setDocumentInfo'
    ]),
    async isValid() {
      return this.validateForm('step-1');
    },
    getStepData() {
      if (this.step.documentType) {
        this.setDocumentInfo(this.$refs.documents.getOption());
      }
      const documentName = this.step.document
        ? {
          documentName: this.$refs.documents.getOption().label
        }
        : {};

      const documentTypeName = this.step.documentType
        ? {
          documentTypeName: this.$refs.documentTypes.getOption().label
        }
        : {};

      const documentOptId = this.step.document
        ? {
          documentOptId: this.$refs.documents.getOption().id
        }
        : {};
      const documentTypeId = this.step.documentType
        ? {
          documentTypeId: this.$refs.documentTypes.getOption().id
        }
        : {};
      return {
        ...this.step,
        ...documentTypeName,
        ...documentName,
        ...documentOptId,
        ...documentTypeId
      };
    }
  }
};

</script>
<style>
.ti-input {
  border-radius: 5px;
}

</style>
